<app-page-shell [title]="'patients_title' | translate" [description]="'patients_desc' | translate" [card]="false">
  <div class="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center w-full sm:w-auto" actions>
    <!-- Search Bar -->
    <p-iconField iconPosition="left" class="w-full sm:w-auto">
      <p-inputIcon styleClass="pi pi-search text-slate-400" />
      <input type="text" pInputText [(ngModel)]="searchTerm" (ngModelChange)="onSearch($event)"
        placeholder="{{ 'patients_search_placeholder' | translate }}"
        class="w-full sm:w-80 !bg-white !border-slate-200 !rounded-xl !text-sm focus:!ring-2 focus:!ring-primary/10 focus:!border-primary !shadow-sm transition-all" />
    </p-iconField>

    <!-- Add Button -->
    <app-button *hasPermission="'Pacientes:create'" (onClick)="openModal()"
      label="{{ 'patients_new_button' | translate }}" icon="pi pi-plus" variant="primary">
    </app-button>
  </div>

  <!-- Table Container -->
  <div *ngIf="patientsData$ | async as result">
    <app-prime-table [columns]="columns" [data]="result.data" [loading]="(loading$ | async) || false"
      [totalRecords]="result.count" [rows]="pageSize" [templates]="templates" [lazy]="true"
      (onPage)="onPageChange(($event.first / $event.rows) + 1)">
    </app-prime-table>

  </div>
</app-page-shell>

<!-- Column Templates -->
<ng-template #photoTemplate let-row>
  <div class="flex items-center gap-3 cursor-pointer group" [routerLink]="['/patients', row.branches_id, (row | patientIdentifier)]" [queryParams]="{ pid: row.id }">
    <div class="relative w-10 h-10 flex-shrink-0">
      <img [appSignedSrc]="row.photo" bucket="patient_documents"
        class="w-10 h-10 rounded-full border border-slate-100 object-cover bg-slate-50 shadow-sm" [alt]="'alt_patient_photo' | translate">
    </div>
    <div class="flex flex-col min-w-0">
      <span class="text-sm font-bold text-slate-900 truncate group-hover:text-primary transition-colors">
        {{ row.name || '-' }}
      </span>
      <span class="text-[10px] text-slate-400 font-black uppercase tracking-wider">
        ID: #{{ row | patientIdentifier }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #statusTemplate let-row>
  <span *ngIf="row.status === 'anonimizado'"
    class="px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest inline-flex items-center gap-2 bg-slate-100 text-slate-500">
    <i class="pi pi-lock text-[9px]"></i>
    {{ 'patients_status_anonymized' | translate }}
  </span>
  <span *ngIf="row.status !== 'anonimizado'"
    [class]="'px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest inline-flex items-center gap-2 ' + (row.status !== 'ativo' ? 'bg-amber-50 text-amber-600' : 'bg-emerald-50 text-emerald-600')">
    <div [class]="'w-1.5 h-1.5 rounded-full ' + (row.status !== 'ativo' ? 'bg-amber-600' : 'bg-emerald-600')"></div>
    {{ row.status ? ((row.status === 'ativo' ? 'status_active' : 'status_inactive') | translate) : '-' }}
  </span>
</ng-template>

<ng-template #cellTemplate let-row>
  <!-- primary_phone, falling back to phone - matching get_patient_details_v3, which
       already returns coalesce(primary_phone, phone). `cell` is deliberately not in
       the chain: it is the landline column. -->
  <span>{{ row.primary_phone || row.phone || '-' }}</span>
</ng-template>

<ng-template #createdByTemplate let-row>
  <div class="flex flex-col min-w-0">
    <span class="text-xs font-bold text-slate-700 truncate">{{ row.created_by_name || '-' }}</span>
    <span class="text-[10px] text-slate-400" *ngIf="row.created_at">{{ row.created_at | date: 'dd/MM/yyyy HH:mm'
      }}</span>
  </div>
</ng-template>

<ng-template #updatedByTemplate let-row>
  <div class="flex flex-col min-w-0">
    <span class="text-xs font-bold text-slate-700 truncate">{{ row.updated_by_name || '-' }}</span>
    <span class="text-[10px] text-slate-400" *ngIf="row.updated_at">{{ row.updated_at | date: 'dd/MM/yyyy HH:mm'
      }}</span>
  </div>
</ng-template>

<ng-template #actionsTemplate let-row>
  <app-dropdown>
    <ng-template #trigger>
      <button [disabled]="row.status === 'anonimizado'"
        class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:text-slate-400 disabled:hover:bg-transparent"
        [title]="'actions' | translate">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 8a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 20a2 2 0 100-4 2 2 0 000 4z" />
        </svg>
      </button>
    </ng-template>
    <ng-template #content>
      <div class="flex flex-col">
        <button *ngIf="row.status !== 'anonimizado'" [routerLink]="['/patients', row.branches_id, (row | patientIdentifier)]" [queryParams]="{ pid: row.id }"
          class="w-full text-left px-4 py-3 text-xs font-black text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors uppercase tracking-widest group/item">
          <svg class="w-4 h-4 text-primary group-hover/item:scale-110 transition-transform" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          {{ 'action_view' | translate }}
        </button>
        <ng-container *hasPermission="'Pacientes:edit'">
        <button *ngIf="row.status !== 'anonimizado'" (click)="openModal(row.id)"
          class="w-full text-left px-4 py-3 text-xs font-black text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors uppercase tracking-widest group/edit">
          <svg class="w-4 h-4 text-primary group-hover/edit:scale-110 transition-transform" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          {{ 'action_edit' | translate }}
        </button>
        </ng-container>
        <ng-container *hasPermission="'Pacientes:edit'">
        <div class="h-px bg-slate-100 my-1" *ngIf="row.status !== 'anonimizado'"></div>
        <button *ngIf="row.status !== 'anonimizado'" (click)="toggleStatus(row)"
          class="w-full text-left px-4 py-2.5 text-xs font-bold flex items-center gap-2 transition-colors uppercase tracking-wider"
          [ngClass]="row.status === 'ativo' ? 'text-amber-600 hover:bg-amber-50' : 'text-emerald-600 hover:bg-emerald-50'">
          <svg *ngIf="row.status === 'ativo'" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
          <svg *ngIf="row.status !== 'ativo'" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {{ (row.status === 'ativo' ? 'action_deactivate' : 'action_activate') | translate }}
        </button>
        </ng-container>
        <ng-container *hasPermission="'Pacientes:delete'">
        <div class="h-px bg-slate-100 my-1" *ngIf="row.status !== 'anonimizado'"></div>
        <button *ngIf="row.status !== 'anonimizado'" (click)="deletePatientGdpr(row)"
          class="w-full text-left px-4 py-2.5 text-xs font-bold text-rose-600 hover:bg-rose-50 flex items-center gap-2 transition-colors uppercase tracking-wider">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          {{ 'action_delete_gdpr' | translate }}
        </button>
        </ng-container>
      </div>
    </ng-template>
  </app-dropdown>
</ng-template>

<app-patient-modal *ngIf="showModal" [patientId]="selectedPatientId" [seed]="patientSeed"
  [linkAppointmentId]="linkAppointmentId" (close)="closeModal()" (saved)="onPatientSaved()">
</app-patient-modal>

<p-confirmDialog styleClass="premium-confirm-dialog" [style]="{'max-width': '500px', width: '90vw'}"
  [baseZIndex]="20000" acceptButtonStyleClass="!bg-rose-500 !border-rose-500 !rounded-xl !px-6 !text-white"
  rejectButtonStyleClass="p-button-text !rounded-xl !px-6 !text-slate-400">
</p-confirmDialog>